import { en } from "./en";
import type { Locale, Messages } from "./types";
import { zhCN } from "./zh-CN";
import { zhTW } from "./zh-TW";

export const messages: Record<Locale, Messages> = { en, "zh-CN": zhCN, "zh-TW": zhTW };
export const SUPPORTED_LOCALES = ["en", "zh-CN", "zh-TW"] as const;

export function localePath(locale: Locale): string {
  return locale === "en" ? "/en/" : locale === "zh-CN" ? "/zh-cn/" : "/zh-tw/";
}

export function localeFromPath(pathname: string): Locale | null {
  const segment = pathname.toLowerCase().split("/").filter(Boolean)[0];
  if (segment === "en") return "en";
  if (segment === "zh-cn") return "zh-CN";
  if (segment === "zh-tw") return "zh-TW";
  return null;
}

export function normalizeLocale(value: string | null | undefined): Locale | null {
  if (!value) return null;
  const locale = value.toLowerCase();
  if (locale === "en" || locale.startsWith("en-")) return "en";
  if (locale === "zh-cn" || locale === "zh-hans" || locale.startsWith("zh-hans-")) return "zh-CN";
  if (
    locale === "zh-tw" ||
    locale === "zh-hk" ||
    locale === "zh-mo" ||
    locale === "zh-hant" ||
    locale.startsWith("zh-hant-")
  )
    return "zh-TW";
  if (locale === "zh" || locale.startsWith("zh-")) return "zh-TW";
  return null;
}

export function detectPreferredLocale(languages: readonly string[]): Locale {
  for (const language of languages) {
    const locale = normalizeLocale(language);
    if (locale) return locale;
  }
  return "zh-TW";
}
